module.exports = __webpack_public_path__ + "static/media/profile_sample.18173468.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/profile_sample.JPG
// module id = 1364
// module chunks = 1